import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ExtractorRoute } from '../../routing'

export  class ExtractorPage extends Component {
    render() {
        return (
            <Fragment>
                <Breadcrumbs />
                <ExtractorRoute />
            </Fragment>
        )
    }
}
